import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../enum/enum";
import { useLoader } from "../../context/loaderContext";
import { useAuth } from "../../context/authContext";
import Layout from "../../layout/layout";
import moment from "moment";

const WithdrawalReport = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const [withdrawalReport, setWithdrawalReport] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const getWithdrawalReport = async () => {
        try {
            const url = `${BaseUrl}App/WithdrawalWalletReport`;

            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "userID": userId,
                    "version": Version
                },
                "request": {
                    "FromDate": fromDate ? moment(fromDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                    "ToDate": toDate ? moment(toDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                    // "WalletId": 0,
                    // "CurrencyId": 0,
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setWithdrawalReport(res.data.withdrawalWalletReport || []);
            } else {
                setWithdrawalReport([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    useEffect(() => {
        getWithdrawalReport();
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Withdrawal Report </h5>
                                    </div>
                                    {/* filters */}
                                    {/* {withdrawalReport?.length > 0 && ( */}
                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >
                                        <div>
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                min={fromDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div>
                                        {/* <div>
                                            <label className="form-label">From User</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="From User..."
                                                value={fromUser}
                                                onChange={(e) => setFromUser(e.target.value)}
                                            />
                                        </div> */}
                                        <div className="d-flex-end">
                                            <button
                                                type="button"
                                                onClick={getWithdrawalReport}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>
                                    {/* // )} */}
                                    {/* records */}
                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            withdrawalReport?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Txn Id</th>
                                                                <th scope="col">Wallet</th>
                                                                <th scope="col">Amount</th>
                                                                <th scope="col">Currency</th>
                                                                <th scope="col">Address</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                withdrawalReport?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{el.tid}</td>
                                                                        <td>{el.toWallet}</td>
                                                                        <td>${el.requestedAmount}</td>
                                                                        <td>{el.fromCurrencyName}</td>
                                                                        <td>{el.toAddress}</td>
                                                                        <td>
                                                                            {
                                                                                el.status == 2 ? <span class='badge bg-success me-1 mb-1 mt-1'>Success</span>
                                                                                    : el.status == 1 ? <span class='badge bg-warning badge-default me-1 mb-1 mt-1'>Pending</span>
                                                                                        : <span class='badge bg-danger badge-default me-1 mb-1 mt-1'>Failed</span>
                                                                            }
                                                                        </td>
                                                                        <td>{el.entryDate}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {withdrawalReport?.length > 0 ? (
                                            withdrawalReport.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.entryDate}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Txn Id:</strong>
                                                        <p className="mb-0 f-w-500">{el.tid}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Wallet:</strong>
                                                        <p className="mb-0 f-w-500">{el.toWallet}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Amount:</strong>
                                                        <p className="mb-0 f-w-500">${el.requestedAmount}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Currency:</strong>
                                                        <p className="mb-0 f-w-500">{el.fromCurrencyName}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Address:</strong>
                                                        <p className="mb-0 f-w-500 ellipsis-left" style={{width: "unset"}}>{el.toAddress}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Status:</strong>
                                                        {
                                                            el.status == 2 ? <span class='badge bg-success me-1 mb-1 mt-1'>Success</span>
                                                                : el.status == 1 ? <span class='badge bg-warning badge-default me-1 mb-1 mt-1'>Pending</span>
                                                                    : <span class='badge bg-danger badge-default me-1 mb-1 mt-1'>Failed</span>
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default WithdrawalReport;